import { Heading } from "@chakra-ui/react";
import React from "react";
export const ThemedHeading = (props) => {
    const getFontSize = () => {
        if (props.as === "h2") {
            return "2.75rem";
        }
        return undefined;
    };
    const getFontWeight = () => {
        if (props.as == "h2") {
            return "200";
        }
        return undefined;
    };
    return React.createElement(Heading, Object.assign({ fontSize: getFontSize(), fontWeight: getFontWeight(), color: "reaBlue.800" }, props));
};
